// extracted by mini-css-extract-plugin
module.exports = {"fixed":"style_fixed__PBs4i","absolute":"style_absolute__EI5m3","overlay":"style_overlay__qrUnY","opaqueBackground":"style_opaqueBackground__cCvcE","spinner":"style_spinner__0tn8-"};